
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 4320 2880"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#ed2939","d":"M0 0h4320v1440H0z"}}),_c('path',{attrs:{"fill":"#fff","d":"M0 1440h4320v1440H0zM1481.678 720a541.5 541.5 0 11-1083 0 541.5 541.5 0 111083 0z"}}),_c('path',{attrs:{"fill":"#ed2939","d":"M1651.835 720a511.735 511.735 0 11-1023.47 0 511.735 511.735 0 111023.47 0z"}}),_c('path',{attrs:{"fill":"#fff","id":"a","d":"M1007.195 733.064l-73.56-56.43-73.542 56.457 28.313-90.994-73.795-56.092 91.06.193 27.934-91.123 27.964 91.113 91.06-.226-73.777 56.119 28.343 90.983z"}}),_c('use',{attrs:{"xlink:href":"#a","transform":"translate(577.189)"}}),_c('use',{attrs:{"xlink:href":"#a","transform":"translate(288.889 -214.211)"}}),_c('use',{attrs:{"xlink:href":"#a","transform":"translate(108 342.749)"}}),_c('use',{attrs:{"xlink:href":"#a","transform":"translate(469.189 342.749)"}})])
          )
        }
      }
    